import { useEffect } from 'react';

import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

import useEffectOnce from 'hooks/use-effect-once';
import { ApiKeys, Service } from 'utils/environment';

export default function useGoogleAnalytics() {
  const location = useLocation();
  const GOOGLE_ANALYTICS_ID: string = ApiKeys.get(Service.googleAnalytics);

  useEffectOnce(() => {
    if (GOOGLE_ANALYTICS_ID) {
      ReactGA.initialize(GOOGLE_ANALYTICS_ID);
    }
  });

  useEffect(() => {
    if (GOOGLE_ANALYTICS_ID) {
      const currentPath = location.pathname + location.search;
      ReactGA.set({ page: currentPath });
      ReactGA.pageview(currentPath);
    }
  }, [location, GOOGLE_ANALYTICS_ID]);
}
